import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../Button';
import { makePharmacyTitle } from '../../../../../utils/makePharmacyTitle';
import PharmacyPopup from '../../../../AppointmentForm/AppointmentPharmacy/PharmacyPopup';

import styles from './styles.styl';

function PreferredPharmacy({
  user,
  formatMessage,
  refillRequestError,
  clearRefillRequest,
  refillRequestPending,
  setPreferredPharmacy,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [pharmacy, setPharmacy] = useState(null);
  const { primaryPatientProfile } = user;

  const togglePopupHandle = () => {
    setIsOpen(current => !current);
  };

  const handleSetPharmacy = preferredPharmacy => {
    clearRefillRequest();
    setPharmacy(preferredPharmacy);
    setPreferredPharmacy({ pharmacyId: preferredPharmacy.id, userId: user.id });
  };

  return (
    <Fragment>
      <div className={styles.root}>
        <div className={styles.locationWrapper}>
          <div className={styles.location}>
            {formatMessage({ id: 'appointments.form.preferredPharmacy' })}
          </div>
          <div className={styles.address}>
            {primaryPatientProfile &&
              makePharmacyTitle(
                pharmacy || primaryPatientProfile.pharmacy,
                true,
              )}
          </div>
        </div>
        <Button
          raised
          color="accent"
          onClick={togglePopupHandle}
          className={styles.button}
          disabled={refillRequestPending}
        >
          {formatMessage({ id: 'appointments.form.changePharmacy' })}
        </Button>
      </div>
      {refillRequestError && (
        <div className={styles.unavailablePharmacy}>
          {formatMessage({ id: 'patient.portal.unavailablePharmacy' })}
        </div>
      )}
      <PharmacyPopup
        isOpen={isOpen}
        withMailOrder={false}
        onClose={togglePopupHandle}
        setPharmacy={handleSetPharmacy}
      />
    </Fragment>
  );
}

PreferredPharmacy.propTypes = {
  user: PropTypes.object,
  formatMessage: PropTypes.func,
  clearRefillRequest: PropTypes.func,
  refillRequestError: PropTypes.bool,
  refillRequestPending: PropTypes.bool,
  setPreferredPharmacy: PropTypes.func,
};

export default PreferredPharmacy;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/Refills/PreferredPharmacy/index.jsx